import React from 'react';

const ThankyouPage = () => {
    return (
        <div className="vh-100 d-flex justify-content-center align-items-center">
            <div className="col-md-5"> {/* Increased the column width */}
                {/* Adding top border radius to the border div */}
                <div className="border border-3" style={{ borderColor: '#0000ff', borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}></div>
                <div className="bg-white shadow p-5" style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
                    <div className="d-flex justify-content-center mb-4"> {/* Center the image */}
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/fintrack_logo.png`}
                            alt="Fintrack Logo"
                            style={{
                                maxWidth: '250px',  // Increased the logo size
                                height: 'auto',
                            }}
                        />
                    </div>
                    <div className="mb-4 text-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="text-success"
                            width="100"  // Increased the SVG size
                            height="100"
                            fill="currentColor"  // Set color of checkmark to #0000ff
                            viewBox="0 0 16 16"
                        >
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path
                                d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                            />
                        </svg>
                    </div>
                    <div className="text-center">
                        <h1 style={{ color: '#0000ff', fontSize: '3rem' }}>Thank You !</h1> {/* Changed color to #0000ff */}
                        <p style={{ fontSize: '1.25rem' }}>You have successfully completed all the steps.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThankyouPage;
